import React from 'react';
import Banner from '../components/common/Banner';

const PlacementsPage = () => {
  const recruiters = [
    { name: 'Microsoft', logo: 'fab fa-microsoft' },
    { name: 'Google', logo: 'fab fa-google' },
    { name: 'Amazon', logo: 'fab fa-amazon' },
    { name: 'Apple', logo: 'fab fa-apple' },
    { name: 'Infosys', logo: 'fas fa-laptop-code' },
    { name: 'TCS', logo: 'fas fa-code' },
    { name: 'Wipro', logo: 'fas fa-desktop' },
    { name: 'IBM', logo: 'fas fa-server' }
  ];

  return (
    <div className="h-full w-full  fade-in">
      <Banner 
        title="Training & Placements"
        subtitle="Career Development | Industry Partnerships | Professional Growth"
        imageSrc="https://images.unsplash.com/photo-1521737711867-e3b97375f902?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80"
      />
      <div className="max-w-6xl mx-auto p-4 sm:p-6 md:p-10 space-y-8 sm:space-y-12">
        
        {/* Placement Coordinator Message */}
        <section>
          <div className="bg-white p-4 sm:p-6 md:p-8 rounded-xl border border-border_gray">
            <div className="grid sm:grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 items-center">
              <div className="bg-slate-50 p-6 rounded-lg text-center">
                <div className="w-24 h-24 bg-crimson rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-user-tie text-white text-3xl"></i>
                </div>
                <h4 className="font-bold text-slate">Dr. [Name]</h4>
                <p className="text-sm text-gray-500">Placement Coordinator</p>
              </div>
              
              <div className="md:col-span-2 space-y-4">
                <h2 className="text-xl sm:text-2xl font-serif font-bold text-slate">Message from Placement Coordinator</h2>
                <p className="text-gray-600 leading-relaxed">
                  Welcome to the Training and Placement Cell of FiT Engineering College. Our dedicated team works 
                  tirelessly to bridge the gap between academic excellence and industry requirements. We are committed to 
                  providing our students with comprehensive career guidance, skill development programs, and placement 
                  opportunities with leading organizations across various sectors.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  Our placement cell focuses on holistic development through personality development sessions, technical 
                  training, soft skills enhancement, and interview preparation. We maintain strong relationships with 
                  industry partners to ensure our graduates are well-prepared for the competitive professional landscape.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Career Guidance & Capacity Building */}
        <section>
          <div className="mb-8">
            <h2 className="text-2xl sm:text-3xl font-serif font-bold text-slate mb-3 sm:mb-4">Career Guidance & Capacity Building</h2>
            <p className="text-gray-500">Comprehensive programs designed to enhance employability and career readiness.</p>
          </div>

          <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
            <div className="bg-white p-4 sm:p-6 rounded-xl border border-border_gray">
              <div className="w-12 h-12 bg-crimson rounded-lg flex items-center justify-center mb-4">
                <i className="fas fa-brain text-white"></i>
              </div>
              <h3 className="text-base sm:text-lg font-bold text-slate mb-2 sm:mb-3">Soft Skills Development</h3>
              <ul className="text-gray-600 text-sm sm:text-base space-y-1">
                <li>• Communication skills workshops</li>
                <li>• Leadership training programs</li>
                <li>• Team building exercises</li>
                <li>• Presentation skills enhancement</li>
              </ul>
            </div>

            <div className="bg-white p-4 sm:p-6 rounded-xl border border-border_gray">
              <div className="w-12 h-12 bg-gold rounded-lg flex items-center justify-center mb-4">
                <i className="fas fa-code text-white"></i>
              </div>
              <h3 className="text-base sm:text-lg font-bold text-slate mb-2 sm:mb-3">Technical Training</h3>
              <ul className="text-gray-600 text-sm sm:text-base space-y-1">
                <li>• Industry-relevant technology training</li>
                <li>• Certification preparation courses</li>
                <li>• Project-based learning</li>
                <li>• Latest technology workshops</li>
              </ul>
            </div>

            <div className="bg-white p-4 sm:p-6 rounded-xl border border-border_gray">
              <div className="w-12 h-12 bg-slate rounded-lg flex items-center justify-center mb-4">
                <i className="fas fa-handshake text-white"></i>
              </div>
              <h3 className="text-base sm:text-lg font-bold text-slate mb-2 sm:mb-3">Interview Preparation</h3>
              <ul className="text-gray-600 text-sm sm:text-base space-y-1">
                <li>• Mock interview sessions</li>
                <li>• Resume building workshops</li>
                <li>• Group discussion training</li>
                <li>• Aptitude test preparation</li>
              </ul>
            </div>

            <div className="bg-white p-4 sm:p-6 rounded-xl border border-border_gray">
              <div className="w-12 h-12 bg-crimson rounded-lg flex items-center justify-center mb-4">
                <i className="fas fa-lightbulb text-white"></i>
              </div>
              <h3 className="text-base sm:text-lg font-bold text-slate mb-2 sm:mb-3">Entrepreneurship</h3>
              <ul className="text-gray-600 text-sm sm:text-base space-y-1">
                <li>• Business plan development</li>
                <li>• Startup incubation support</li>
                <li>• Industry mentorship programs</li>
                <li>• Innovation challenges</li>
              </ul>
            </div>

            <div className="bg-white p-4 sm:p-6 rounded-xl border border-border_gray">
              <div className="w-12 h-12 bg-gold rounded-lg flex items-center justify-center mb-4">
                <i className="fas fa-chart-line text-white"></i>
              </div>
              <h3 className="text-base sm:text-lg font-bold text-slate mb-2 sm:mb-3">Career Counseling</h3>
              <ul className="text-gray-600 text-sm sm:text-base space-y-1">
                <li>• Individual career assessment</li>
                <li>• Industry exposure programs</li>
                <li>• Career path guidance</li>
                <li>• Alumni mentorship network</li>
              </ul>
            </div>

            <div className="bg-white p-4 sm:p-6 rounded-xl border border-border_gray">
              <div className="w-12 h-12 bg-slate rounded-lg flex items-center justify-center mb-4">
                <i className="fas fa-certificate text-white"></i>
              </div>
              <h3 className="text-base sm:text-lg font-bold text-slate mb-2 sm:mb-3">Certification Programs</h3>
              <ul className="text-gray-600 text-sm sm:text-base space-y-1">
                <li>• Industry certification courses</li>
                <li>• Professional skill certifications</li>
                <li>• Online platform partnerships</li>
                <li>• International certification prep</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Our Recruiters */}
        <section>
          <div className="mb-6 sm:mb-8">
            <h2 className="text-2xl sm:text-3xl font-serif font-bold text-slate mb-3 sm:mb-4">Our Recruiters</h2>
            <p className="text-gray-500">Leading organizations that regularly recruit from our campus.</p>
          </div>

          <div className="bg-white p-4 sm:p-6 md:p-8 rounded-xl border border-border_gray">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
              {recruiters.map((recruiter, index) => (
                <div key={index} className="text-center group">
                  <div className="w-20 h-20 bg-gray-100 rounded-xl flex items-center justify-center mx-auto mb-3 group-hover:bg-crimson group-hover:text-white transition duration-300">
                    <i className={`${recruiter.logo} text-3xl text-gray-400 group-hover:text-white`}></i>
                  </div>
                  <h4 className="font-semibold text-slate text-sm">{recruiter.name}</h4>
                </div>
              ))}
            </div>

            <div className="mt-8 p-4 bg-blue-50 border border-blue-200 rounded-lg text-center">
              <h4 className="font-semibold text-blue-800 mb-2">Placement Statistics</h4>
              <div className="grid sm:grid-cols-1 md:grid-cols-3 gap-4 text-blue-700">
                <div>
                  <div className="text-2xl font-bold">90%+</div>
                  <div className="text-sm">Placement Rate</div>
                </div>
                <div>
                  <div className="text-2xl font-bold">150+</div>
                  <div className="text-sm">Partner Companies</div>
                </div>
                <div>
                  <div className="text-2xl font-bold">₹8L+</div>
                  <div className="text-sm">Highest Package</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Information */}
        <section>
          <div className="bg-white p-4 sm:p-6 md:p-8 rounded-xl border border-border_gray">
            <h2 className="text-xl sm:text-2xl font-serif font-bold text-slate mb-4 sm:mb-6">Get in Touch</h2>
            <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 lg:gap-8">
              <div>
                <h4 className="font-semibold text-slate mb-4">For Students</h4>
                <div className="space-y-3 text-gray-600">
                  <p><i className="fas fa-envelope text-crimson mr-2"></i> placements@fit.ac.in</p>
                  <p><i className="fas fa-phone text-crimson mr-2"></i> +91 98765-43210</p>
                  <p><i className="fas fa-clock text-crimson mr-2"></i> Monday - Friday, 9:00 AM - 6:00 PM</p>
                </div>
              </div>
              
              <div>
                <h4 className="font-semibold text-slate mb-4">For Recruiters</h4>
                <div className="space-y-3 text-gray-600">
                  <p><i className="fas fa-envelope text-crimson mr-2"></i> corporate@fit.ac.in</p>
                  <p><i className="fas fa-phone text-crimson mr-2"></i> +91 98765-43211</p>
                  <button className="bg-crimson hover:bg-red-800 text-white font-bold py-2 px-4 sm:px-6 rounded transition text-sm sm:text-base">
                    <i className="fas fa-download mr-2"></i>
                    Company Brochure
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

      </div>
    </div>
  );
};

export default PlacementsPage;